import createRepository from './generic';

export default () => createRepository('rankeds', 'leaderboardId');